module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thread"
  }, [_c('h1', {
    staticClass: "thread__title"
  }, [_vm._v(_vm._s(_vm.body.title))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "score--positive"
  }, [_vm._v("▲")]), _vm._v(" " + _vm._s(_vm.body.score) + " | submitted by " + _vm._s(_vm.body.author) + " | " + _vm._s(_vm._f("UNIXtimeAgo")(_vm.body.created_utc)))]), _vm._v(" "), (_vm.body.selftext) ? _c('div', {
    staticClass: "thread__self-text",
    domProps: {
      "innerHTML": _vm._s(_vm.marked)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comments.length) ? _c('ul', {
    staticClass: "thread__comments"
  }, _vm._l((_vm.comments), function(comment) {
    return (_vm.comments.length && comment.kind !== 'more') ? _c('comment', {
      attrs: {
        "comment": comment.data,
        "depth": 0
      }
    }) : _vm._e()
  }), 1) : _c('div', {
    staticClass: "thread__comments-loading"
  }, [_vm._v("\n    Loading Comments...\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a36923e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thread.vue
// module id = 294
// module chunks = 2